import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { createContext, Suspense, useState } from "react";
import givefrontLogo from "@/assets/brand/givefrontlogofull.png";
import { trpc } from "@/lib/trpcClient";
import { env } from "../../../../env";
import { CardCreationStep } from "./onboard/-components/card-creation-step";
import { FinishStep } from "./onboard/-components/finish-step";
import { IntroStep } from "./onboard/-components/intro-step";
import { MemberInviteStep } from "./onboard/-components/member-invite-step";

export const Route = createFileRoute("/_authed/_onboard/onboard/approved")({
  component: RouteComponent,
});

const steps = [
  <IntroStep key="intro-step" />,
  <CardCreationStep key="card-creation" />,
  <MemberInviteStep key="member-invite" />,
];

function RouteComponent() {
  const {
    data: { org },
  } = useSuspenseQuery(trpc.auth.session.queryOptions());

  const prodMode = localStorage.getItem("prodMode") === "true";
  const greyOut = env.VITE_ENVIRONMENT !== "production" && !prodMode;

  const [step, setStep] = useState(0);
  const increaseStep = () => setStep((i) => i + 1);

  const navigate = Route.useNavigate();

  if (org?.status !== "approved") return navigate({ to: "/onboard" });

  return (
    <OnboardingContext.Provider value={{ increaseStep }}>
      <div className="flex min-h-screen max-w-screen flex-col items-center justify-center overflow-hidden bg-gray-50 py-12">
        {step < steps.length && (
          <img
            alt="Givefront Logo"
            className={`mb-10 h-16 w-auto ${greyOut ? "opacity-50 grayscale" : ""}`}
            src={givefrontLogo}
          />
        )}

        <Suspense fallback={<Loader2 className="size-8 animate-spin" />}>
          {steps[step] ?? <FinishStep />}
        </Suspense>
      </div>
    </OnboardingContext.Provider>
  );
}

export const OnboardingContext = createContext({
  increaseStep: () => {},
});
